// extracted by mini-css-extract-plugin
export default {"quizBox":"QuizBox_quizBox__VGpNq","btnWrap":"QuizBox_btnWrap__3gowe","scoreStyle":"QuizBox_scoreStyle__ARx6p"};